import { render, staticRenderFns } from "./ResourceTypesFilter.vue?vue&type=template&id=2e26c04a&scoped=true&"
import script from "./ResourceTypesFilter.vue?vue&type=script&lang=js&"
export * from "./ResourceTypesFilter.vue?vue&type=script&lang=js&"
import style0 from "./ResourceTypesFilter.vue?vue&type=style&index=0&id=2e26c04a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e26c04a",
  null
  
)

export default component.exports